import React, { useRef, useCallback } from 'react';

import useMediaStore from '../../../../common/store/useMediaStore';
import Apple from '../../../../common/components/glb/Apple';
import useFloatAnimation from './useFloatAnimation';

const StaticApples = () => {
  const md = useMediaStore(useCallback(state => state.md, []));

  const uno = useRef<THREE.Group>(null);
  const dos = useRef<THREE.Group>(null);
  const tres = useRef<THREE.Group>(null);
  const cuatro = useRef<THREE.Group>(null);
  const cinco = useRef<THREE.Group>(null);
  const sies = useRef<THREE.Group>(null);

  useFloatAnimation([uno, dos, tres, cuatro, cinco, sies]);

  return (
    <>
      <group ref={uno}>
        <Apple type="quarter" position={[-1.79, -2.24, -0.67]} rotation={[-2.33, 0.75, 1.47]} />
      </group>

      <group ref={dos}>
        <Apple type="half" position={[2.32, 2.1, -1.38]} rotation={[0.48, -0.81, -0.56]} />
      </group>

      <group ref={tres}>
        <Apple type="quarter" position={[0.9, -1.78, 1.56]} rotation={[0.42, -3.2, -2.0]} />
      </group>

      <group ref={cuatro}>
        <Apple type="quarter" scale={1.5} position={[-1.4, 2.75, 0]} rotation={[0, 7.71, 1.32]} />
      </group>

      <group ref={cinco}>
        {md && <Apple type="half" scale={2} position={[-5.98, 0.9, -1.87]} rotation={[-0.59, 1.56, 1.19]} />}
      </group>

      <group ref={sies}>
        {md && <Apple type="quarter" position={[5.45, -0.32, -1.42]} rotation={[3.27, 3.88, 2.92]} />}
      </group>
    </>
  );
}

export default StaticApples;